module.exports = __webpack_public_path__ + "img/Lab_Book_Icon_Underline.9ad903ca.svg";